import type { LinkUrl } from '/types/index.d';

import { faArrowRight, faExternalLink } from '@fortawesome/pro-light-svg-icons';
import React from 'react';

import { FontAwesomeIconWrapper } from '/react4xp/components/FontAwesomeIconWrapper';


export function LinkIcon({
	className,
	link,
}: {
	className?: string;
	link?: LinkUrl;
}): JSX.Element | null {
	if (!link) return null;

	const { isExternalLink } = link;

	return <FontAwesomeIconWrapper
		className={className}
		size='lg'
		icon={isExternalLink ? faExternalLink : faArrowRight}
		fixedWidth={true}
	/>;
}
